export default "/images/424684dab78956e434261f7d1c1b662f.avif";